<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Controles de Stock">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="controlesStock" 
              :fields="fields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fechaHora }}
            </template>
            <template v-slot:cell(fechaFinalizacion)="data">
              {{ data.item.fechaFinalizacion | fechaHora }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <!-- <b-dropdown-item @click.stop="exportPDF(data.item)">
                  <i class="fa fa-file-pdf-o"></i>Emitir Certificado</b-dropdown-item> -->
                <b-dropdown-item @click.stop="editarItem(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Control</b-dropdown-item>
                <b-dropdown-item @click.stop="borrarItem(data.item)">
                  <i class="fa fa-remove"></i>Borrar Control</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'controlesStock/getField',
  mutationType: 'controlesStock/updateField',
});

export default {
  name: 'ControlesStockList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      fields: [
        {
          key: 'id',
          label: 'Nro.',
          sortable: true
        },
        {
          key: 'fechaRegistro',
          label: 'Fecha'
        },
        {
          key: 'fechaFinalizacion',
          label: 'Fecha Finaliz.'
        },
        {
          key: 'usuario',
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'controlesStock',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      // this.sortByDescending = filtro.sortByDescending;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('controlesStock/getControlesStock')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregar () {
      this.$router.push({ name: 'ControlStockABM', 
                          params: { id: 0 }});
    },
    editarItem (item) {
      this.$router.push({ name: 'ControlStockABM', 
                          params: { id: item.id }});
    },
    consultar (item) {
      this.$router.push({ name: 'ControlStockData', 
                          params: { id: item.id }});
    },
    borrarItem (item) {
      this.showModalConfirm('¿Desea borrar el control de stock seleccionado?', 
            this.borrar.bind(this, item.id), 'Si', null, 'No')
    },
    borrar (controlStockId) {
      this.showSpinner();
      this.$store.dispatch('controlesStock/delete', controlStockId)
        .then(() => this.showModalMsj('El control de stock se borró con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
